<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    width="90%"
    @close="close"
  >
    <el-form ref="form" label-width="100px" :model="form" :rules="rules">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>
      <el-form-item label="副标题" prop="subtitle">
        <el-input v-model="form.subtitle" />
      </el-form-item>
      <el-form-item label="动态封面" prop="image">
        <el-upload
          :multiple="false"
          :limit="1"
          :class="{ disabled: form.image.length > 0 }"
          :action="QNUploadURL"
          :data="uploadToken"
          list-type="picture-card"
          :file-list="form.image"
          :on-success="faceImage_success"
          :on-remove="faceImage_remove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="正文" prop="text">
        <tinymce-editor :height="900" :value="form.text" @inputChange="inputChange"></tinymce-editor>
      </el-form-item>
      <el-form-item label="动态作者" prop="senderName">
        <el-input v-model="form.senderName" />
      </el-form-item>
      <el-form-item label="作者头像" prop="senderIcon">
        <el-upload
          :multiple="false"
          :limit="1"
          :class="{ disabled: form.senderIcon.length > 0 }"
          :action="QNUploadURL"
          :data="uploadToken"
          list-type="picture-card"
          :file-list="form.senderIcon"
          :on-success="avatarImage_success"
          :on-remove="avatarImage_remove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createEssay, updateEssay } from '@/api/apartment'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'Edit',
  emits: ['fetch-data'],
  data() {
    return {
      list: [],
      QNUploadURL,
      QNHost,
      uploadToken: '',
      form: {
        essayId: '',
        title: '',
        subtitle:'',
        image: [],
        senderName: '',
        senderIcon: [],
        text: '',
        order: '',
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入动态标题' }],
        subtitle: [{ required: true, trigger: 'blur', message: '请输入动态副标题' }],
        senderName: [
          { required: true, trigger: 'blur', message: '请输入动态作者姓名' },
        ],
        image: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传动态封面图片'))
              } else {
                callback()
              }
            },
          },
        ],
        senderIcon: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传动态作者头像'))
              } else {
                callback()
              }
            },
          },
        ],
        text: [{ required: true, trigger: 'blur', message: '请输入正文' }],
      },
      title: '',
      dialogFormVisible: false,
    }
  },
  mounted() {
  },
  methods: {
    inputChange(value) {
      this.form.text = value
    },
    avatarImage_remove(file, fileList) {
      this.form.senderIcon = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    avatarImage_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.senderIcon.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    faceImage_remove(file, fileList) {
      this.form.image = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    faceImage_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.image.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    async showEdit(row) {
      if (row.essayId) {
        this.title = '编辑动态'
        this.form = Object.assign(this.form, {
          ...row.basic,
          title: row.title,
          essayId: row.essayId
        })
      } else {
        this.title = '新增动态'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    async save() {
      this.$refs['form'].validate(async (valid) => {
        const essayId = this.form.essayId
        this.$baseConfirm(
          `你确定${essayId ? '修改' : '新增'}该动态吗`,
          null,
          async () => {
            essayId
              ? await updateEssay({ ...this.form })
              : await createEssay({ ...this.form })
            this.$baseMessage(
              `${essayId ? '修改' : '新增'}动态成功`,
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          }
        )
      })
    },
  },
}
</script>

<style style="scss">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
